"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

var warnOnce = require("@atlaskit/ds-lib/warn-once").default;

warnOnce("The '@atlaskit/icon-priority' package has been deprecated due to its limited usage in Cloud Products. If you depend on '@atlaskit/icon-priority' we recommend self-managing the assets.")

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PriorityHighestIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.005 8.187l-6.453 3.865a1 1 0 01-1.028-1.716l6.97-4.174a1 1 0 011.031.002l6.906 4.174a1 1 0 11-1.035 1.712l-6.39-3.863z" fill="#FF5630"/><path d="M5.552 18.054a1 1 0 11-1.028-1.715l6.97-4.174a1 1 0 011.031.002l6.906 4.174a1 1 0 11-1.035 1.711l-6.39-3.862-6.454 3.864z" fill="#FF7452"/></svg>`
}, props));

PriorityHighestIcon.displayName = 'PriorityHighestIcon';
var _default = PriorityHighestIcon;
exports.default = _default;
